export const getTargetQuestionDetails = (value: string) => {
	let targetQuestionType: "MULTIPLE" | "END_OF_FORM" | "NEXT" | null = null;
	let targetQuestionId: number | null = null;

	if (value === "NEXT") {
		targetQuestionType = "NEXT";
	} else if (value === "END_OF_FORM") {
		targetQuestionType = "END_OF_FORM";
	} else {
		targetQuestionType = "MULTIPLE";
		targetQuestionId = parseInt(value);
	}

	return { targetQuestionType, targetQuestionId };
};
